import { FC } from 'react';
import classNames from 'classnames';

interface CountdownTimerProps {
  remainingMs: number;
  isExpired: boolean;
  durationMs: number;
}

export const CountdownTimer: FC<CountdownTimerProps> = ({ remainingMs, isExpired, durationMs }) => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  const radius = 62;
  const circumference = 2 * Math.PI * radius;
  const progress = durationMs > 0 ? Math.max(0, Math.min(1, remainingMs / durationMs)) : 0;
  const dashOffset = circumference * (1 - progress);

  return (
    <div className="relative flex items-center justify-center w-[140px] h-[140px]">
      <svg width="140" height="140" className="absolute inset-0 transform -rotate-90">
        <circle
          cx="70"
          cy="70"
          r={radius}
          stroke="#DEC05E33"
          strokeWidth="4"
          fill="transparent"
        />
        <circle
          cx="70"
          cy="70"
          r={radius}
          stroke="#DEC05E"
          strokeWidth="4"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
          fill="transparent"
        />
      </svg>
      <div
        className={classNames(
          'relative z-[1] text-[34px] font-bold tracking-wide transition-all',
          isExpired ? 'text-[#C00000] animate-pulse' : 'text-[#2C3038]',
        )}
      >
        {formattedTime}
      </div>
    </div>
  );
};
